export class WbDrawers {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    document.querySelectorAll('.wb-drawer__toggle').forEach((el) => {
      el.addEventListener('click', (e) => this.toggle(e));
    });
  }

  toggle(e) {
    const target = e.currentTarget;
    const details = target.closest('.wb-drawer').querySelector('.wb-drawer__content');

    if (target.classList.contains('is-animating')) {
      return;
    }

    target.classList.add('is-animating');
    target._toggleAriaExpanded();
    details._slideToggle().then(() => target.classList.remove('is-animating'));
  }
}
